import { Avatar, Box, Stack, Typography, Tooltip } from "@mui/material";
import { useState, useRef, useEffect } from "react";
// config
import colors from "../../../config/colors";
// components
import Followers from "../list-view/Followers";
// icons
import AddIcon from "@mui/icons-material/Add";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
// redux
import { useDispatch } from "../../../redux/store";
import { setWishlistCreatorId } from "../../../redux/slices/creator";
// ga
import {
  triggerGa,
  CATEGORY,
  ACTION,
  PAGE,
  SCREEN,
  LABEL,
  LABEL2,
} from "../../../utils/gaUtils";
import CreatorSubDetails from "./CreatorSubDetails";

const ProfileInfo = ({ item }) => {
  const dispatch = useDispatch();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const timeoutRef = useRef(null);

  const categories =
    item?.product_categories
      ?.slice() // Create a copy of the array first
      ?.sort((a, b) => b.percentage - a.percentage) // Sort by percentage descending
      ?.slice(0, 2) // Take top 2 categories
      ?.map((item) => item?.category) || [];
  const tags = [...categories];
  const handleAddToWishlist = (e) => {
    e.stopPropagation();
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.ADD_TO_WISHLIST,
      label: item?.username,
      label2: LABEL2.ATTEMPT,
      label3: LABEL2.PROFILE_INTEREST,
      page: PAGE.CREATOR_DISCOVER,
      screenName: SCREEN.CREATOR_DRAWER,
    });
    dispatch(setWishlistCreatorId(item?.wishlink_username));
  };

  const handleTooltipClick = (e) => {
    e.stopPropagation();
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.BUTTON_CLICK,
      label: item?.username,
      label2: LABEL2.ATTEMPT,
      label3: LABEL2.PROFILE_INTEREST,
      page: PAGE.CREATOR_DISCOVER,
      screenName: SCREEN.CREATOR_DRAWER,
    });
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (!tooltipOpen) {
      // Show tooltip and set timer to hide it after 2 seconds
      setTooltipOpen(true);
      timeoutRef.current = setTimeout(() => {
        setTooltipOpen(false);
        timeoutRef.current = null;
      }, 2000);
    } else {
      // If already open, close it immediately
      setTooltipOpen(false);
      timeoutRef.current = null;
    }
  };

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Avatar sx={{ width: 80, height: 80 }} src={item?.avatar} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          flex: 1,
          gap: 1,
        }}
      >
        <Typography fontSize={16} fontWeight={500} lineHeight="20px" noWrap>
          @{item?.username}
        </Typography>
        <CreatorSubDetails item={item} />
        <Stack direction="row" gap={1} flexWrap="wrap">
          {tags?.map((tag) => (
            <Box
              key={tag}
              sx={{
                backgroundColor: colors.primary200,
                padding: "4px 8px",
                borderRadius: 0.5,
                textAlign: "center",
                minWidth: "fit-content",
                display: "inline-block",
              }}
            >
              <Typography fontSize={12} fontWeight={400} lineHeight="16px">
                {tag}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
      <Stack direction={"row"} alignItems={"center"} gap={1} flex="1">
        <Box
          sx={{
            border: `1px solid ${colors.gray100}`,
            borderRadius: "4px",
            p: "10px",
            gap: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: colors.white,
            flex: 1,
          }}
          onClick={handleAddToWishlist}
        >
          <AddIcon
            sx={{
              fontSize: 18,
              color: colors.primary500,
              opacity: 0.7,
              fontWeight: 900,
              lineHeight: "20px",
            }}
          />
          <Typography
            fontSize={14}
            fontWeight={500}
            lineHeight="18px"
            color={colors.gray200}
          >
            Add
          </Typography>
        </Box>
        <Tooltip
          title="Chat coming soon!"
          arrow
          open={tooltipOpen}
          disableFocusListener
          disableHoverListener
          disableTouchListener
        >
          <Box
            sx={{
              border: `1px solid ${colors.gray100}`,
              borderRadius: "4px",
              p: "10px",
              gap: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: colors.white,
              flex: 1,
            }}
            onClick={handleTooltipClick}
          >
            <EmailOutlinedIcon
              sx={{
                fontSize: 18,
                color: colors.primary500,
                opacity: 0.7,
                fontWeight: 900,
                lineHeight: "20px",
              }}
            />
            <Typography
              fontSize={14}
              fontWeight={500}
              lineHeight="18px"
              color={colors.gray200}
            >
              Contact
            </Typography>
          </Box>
        </Tooltip>
      </Stack>
    </Box>
  );
};

export default ProfileInfo;
